import { useMutation, useIsMutating } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import {
  editIFrame,
  updateDigitalAssetService,
  updateDigitalReplaceAssetService,
} from 'services/digitalAsset';

import gridSelector from 'common/components/grid-view/controllers/selectors';
import * as assetSelectors from 'pages/asset-full-view/controllers/selectors';

const REPLACE_ASSET_MUTATION = ['replace-asset-mutation'];

export const useReplaceAssetMutation = () => {
  const replaceAssetMutation = useMutation({
    mutationKey: REPLACE_ASSET_MUTATION,
    mutationFn: async (params) => {
      const response = await updateDigitalReplaceAssetService(params);
      return response;
    },
  });
  const isReplaceAssetLoading =
    useIsMutating({ mutationKey: REPLACE_ASSET_MUTATION }) > 0;
  return {
    replaceAssetMutation,
    isReplaceAssetLoading,
  };
};

export const useGetFromTdcImageWhenReplaceAsset = () => {
  const assetData = useSelector(assetSelectors.assetDataLoading());

  const itemCurrentSelection = useSelector(
    gridSelector.makeSelectItemCurrentSelection()
  );

  return assetData
    ? assetData?.fromTdcImage
    : itemCurrentSelection?.fromTdcImage;
};

export const UPDATE_ASSET_KEY = ['update-asset'];
export const UPDATE_IFRAME_KEY = ['update-iframe'];

export const useUpdateDigitalAssetMutation = () => {
  const assetMutation = useMutation({
    mutationKey: UPDATE_ASSET_KEY,
    mutationFn: async (params) => {
      const response = await updateDigitalAssetService(params);
      return response;
    },
  });
  const iframeMutation = useMutation({
    mutationKey: UPDATE_IFRAME_KEY,
    mutationFn: async (params) => {
      const response = await editIFrame(params);
      return response;
    },
  });

  return {
    assetMutation,
    iframeMutation,
  };
};
